export interface AppShellUser {
  avatar?: string
  email?: string
  id?: string
  name?: string
  role?: string
  status?: string
}

export function getDisplayName(user: AppShellUser, fallbackName = '用户') {
  const trimmedName = user.name?.trim()

  if (trimmedName) {
    return trimmedName
  }

  const trimmedEmail = user.email?.trim()

  if (trimmedEmail) {
    return trimmedEmail
  }

  return fallbackName
}

export function getUserInitial(user: AppShellUser, fallbackName?: string) {
  const displayName = getDisplayName(user, fallbackName)
  return displayName.trim().charAt(0).toUpperCase() || 'U'
}

export function getUserEmail(user: AppShellUser) {
  const trimmedEmail = user.email?.trim()

  if (trimmedEmail) {
    return trimmedEmail
  }

  return 'user@avaca.ai'
}
